import {
  ElementRef,
  Component,
  OnInit,
  Injector,
  Input,
  OnDestroy,
  Output,
  HostListener,
  EventEmitter,
  ViewEncapsulation
} from "@angular/core";
import { BaseComponent } from "../../base.component";
import { isEmpty, includes } from "lodash";
import { constants } from "../../../Utils/constans";

@Component({
  selector: "round-image-multiselect",
  encapsulation: ViewEncapsulation.None,
  template: `
    <div
      role="dialog"
      class="round-image-multiselect options-list-container"
      [hidden]="allOptions.length > 0"
    >
      <ul class="option-list-items" role="group">
        <li
          tabindex="0"
          *ngFor="let option of allOptions; index as i"
          role="menuitem"
          class="option-list-item"
          [ngClass]="{
            selected: isValueSelected(option.value),
            hovered: isHovered(option)
          }"
          (keydown)="checkWithKeyBoard($event, option)"
          (click)="toggle(option.value)"
          (mouseenter)="setHoveredId(i)"
          (mouseleave)="onMouseLeave()"
          (focus)="setHoveredId(i)"
          (blur)="onListItemBlur(i, this.prevEvent)"
        >
          <div class="check-mark-container">
            <div class="check-mark"></div>
          </div>
          <div class="title">
            <span
              class="kb-key"
              [attr.data-kb-key]="option.title[0].toLowerCase()"
              >{{ option.title }}</span
            >
          </div>
        </li>
      </ul>
    </div>
  `,
  styleUrls: ["./round-image-multiselect.component.scss"]
})
export class RoundImageMultiSelectComponent extends BaseComponent
  implements OnInit, OnDestroy {
  @Input() options: any;
  @Input() isOpen: any;
  @Input() parentValue: any;
  @Input() mode: any;
  allOptions: any;
  hoveredId: any;
  //keyCheck: any;
  selectedKeyIndex;
  any;
  searchTerm: any;
  @Output() isSelected: EventEmitter<any> = new EventEmitter();
  @Output() ToggleRoundImageMultiSelect: EventEmitter<any> = new EventEmitter();
  @Output() CloseDropDownListOnTabExit: EventEmitter<any> = new EventEmitter();
  prevEvent: any;

  constructor(injector: Injector, private el: ElementRef) {
    super(injector);
  }

  @HostListener("document:keydown", ["$event"])
  public onClick(targetElement) {
    this.KeyCheck(targetElement);
  }

  ngOnInit() {
    this.searchTerm = "";
    this.allOptions = this.options;
    this.hoveredId = -1;
    this.selectedKeyIndex = -1;
    //this.keyCheck = this.KeyCheck.bind(this);
  }

  ngOnDestroy() {
    //document.onkeydown(this.keyCheck)
  }

  KeyCheck(e) {
    if (!this.shouldRun(this.el.nativeElement)) {
      return false;
    }

    this.prevEvent = e;
    const keyCode = e.keyCode;
    switch (keyCode) {
      case constants.KEYS.DOWN: {
        //e.preventDefault();
        this.hoveredId = this.getNextHoveredId();
        this.selectedKeyIndex = this.hoveredId - 1;
        this.searchTerm = this.allOptions[
          this.hoveredId
        ].title[0].toLowerCase();
        this.el.nativeElement.querySelectorAll("li")[this.hoveredId].focus();

        this.scrollToOptions();
        return;
      }
      case constants.KEYS.UP: {
        //e.preventDefault();
        this.hoveredId = this.getPreviousHoveredId();
        this.selectedKeyIndex = this.hoveredId - 1;
        this.searchTerm = this.allOptions[
          this.hoveredId
        ].title[0].toLowerCase();
        this.el.nativeElement.querySelectorAll("li")[this.hoveredId].focus();

        this.scrollToOptions();
        return;
      }
      case constants.KEYS.SPACE: {
        return;
      }

      case constants.KEYS.TAB: {
        return;
      }

      case constants.KEYS.SHIFT: {
        return;
      }
    }
  }

  getPreviousHoveredId() {
    const length = this.allOptions.length;
    const lastIndex = length - 1;

    return this.hoveredId === -1
      ? lastIndex
      : (this.hoveredId + lastIndex) % length;
  }

  shouldRun(elem: any) {
    return true;
    // const parentControl = this.getParentControl(elem);
    // if (parentControl && parentControl.attr('data-hover')) {
    // 	return true;
    // }
    // return false; todo
  }

  getParentControl(elem) {
    let thisParent = elem.parent(); //elem.parent();todo
    while (!thisParent[0].tagName || thisParent[0].tagName !== "CONTROL") {
      thisParent = this.getParentControl(thisParent);
      if (
        !thisParent ||
        (thisParent[0].tagName && thisParent[0].tagName === "BODY")
      ) {
        return null;
      }
    }
    return thisParent;
  }

  getNextHoveredId() {
    // cancel calculation of next hoveredId if no results
    if (isEmpty(this.allOptions)) {
      return this.hoveredId;
    }

    const length = this.allOptions.length;

    return (this.hoveredId + 1) % length;
  }

  isHovered(option) {
    return this.allOptions[this.hoveredId] === option;
  }

  toggle(value) {
    return this.ToggleRoundImageMultiSelect.emit({ value: value });
  }

  isValueSelected(value) {
    if (this.mode == "radio") {
      return value == this.parentValue;
    }
    if (this.mode == "multi") {
      return includes(this.parentValue, value);
    }
  }

  setHoveredId(id) {
    this.hoveredId = id;
  }

  scrollToOptions() {
    if (this.searchTerm && this.searchTerm.length > 0) {
      let keysMap = [];
      let nextIndex = -1;

      // Find selected index & populate map of keys
      for (
        var i = 0;
        i < this.el.nativeElement.querySelectorAll(".kb-key").length;
        i++
      ) {
        const option = this.el.nativeElement.querySelectorAll(".kb-key")[i];
        const optionValue = option.attributes["data-kb-key"].value;
        keysMap.push(optionValue);
        if (
          this.value &&
          option.textContent.trim().toLowerCase() ===
            this.value.title.trim().toLowerCase()
        ) {
          this.selectedKeyIndex = i;
        }
      }

      // Running for the first time
      if (this.selectedKeyIndex === -1) {
        nextIndex = 0;
      }

      // Match next key
      for (var j = this.selectedKeyIndex + 1; j < keysMap.length; j++) {
        if (keysMap[j] === this.searchTerm) {
          nextIndex = j;
          break;
        }
      }

      // Key not exists, select first key
      if (nextIndex === -1) {
        for (var i = 0; i < keysMap.length; i++) {
          if (keysMap[i] === this.searchTerm) {
            nextIndex = i;
            break;
          }
        }
      }

      // First key not exist, set default
      if (nextIndex === -1) {
        nextIndex = 0;
      }

      this.selectedKeyIndex = nextIndex;

      var that = this;
      setTimeout(() => {
        // Remove any hovered highlights
        const hovered = this.el.nativeElement.querySelectorAll(".hovered");
        if (hovered && hovered.length > 0) {
          for (var i = 0; i < hovered.length; i++) {
            this.el.nativeElement
              .querySelectorAll(".option-list-item.hovered")
              [i].classList.remove("hovered");
          }
        }

        const scrollWrap = this.el.nativeElement.querySelector(
          ".options-list-container"
        );
        const activeElem = this.el.nativeElement.querySelectorAll("li")[
          this.selectedKeyIndex
        ];

        // Scroll to selected element
        if (scrollWrap && activeElem) {
          activeElem.className = activeElem.className += " hovered";
          const scrollWrapRec = scrollWrap.getBoundingClientRect();
          const activeElemRec = activeElem.getBoundingClientRect();

          if (scrollWrapRec.bottom < activeElemRec.bottom) {
            this.el.nativeElement.scrollTop +=
              activeElemRec.top - scrollWrapRec.top;
          } else if (scrollWrapRec.bottom > activeElemRec.bottom) {
            this.el.nativeElement.scrollTop -=
              scrollWrapRec.top - activeElemRec.top;
          }
        }
      }, 100);
    }
  }

  checkWithKeyBoard(event, option) {
    if (event.keyCode === 32 || event.keyCode === 13) {
      this.toggle(option.value);
      event.preventDefault();
    }
  }

  onMouseLeave() {
    this.el.nativeElement.querySelectorAll("li.hovered")[0].blur();
  }

  /*
  When drop down list is opened (e.g. 'Construction/structure type')
  We want to close the drop down list when exiting from it (in both ways: with TAB or with SHIFT TAB)
  We need to detect the exit from the list with SHIFT TAB from the first list item or the exit with
  TAB from the last list item
  */
  onListItemBlur(i, prevEvent) {
    if (i == 0 && prevEvent.shiftKey === true) {
      this.CloseDropDownListOnTabExit.emit();
      return;
    }

    if (
      i == this.allOptions.length - 1 &&
      prevEvent.key.toUpperCase() === "TAB" &&
      prevEvent.shiftKey === false
    ) {
      this.CloseDropDownListOnTabExit.emit();
      return;
    }
  }
}
